import type { FlatIconButtonProps } from '@packages/shared';
import { FlatIconButton } from '@packages/shared';
import { ArrowMediumDown32 } from '@packages/themes/icons';

type ExpandMoreIconProps = FlatIconButtonProps & {
  expanded: boolean;
};

export const ExpandMoreIcon = (props: ExpandMoreIconProps) => {
  const { expanded, ...other } = props;
  return (
    <FlatIconButton
      {...other}
      sx={{
        p: 0,
        transform: !expanded ? 'rotate(0)' : 'rotate(180deg)',
        transition: (theme) =>
          theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
          }),
      }}
    >
      <ArrowMediumDown32 />
    </FlatIconButton>
  );
};
